import * as Utils from '@/assets/script/utils'
import { INFO_TYPE } from '@/constant/infoType'

class InfoModel {

  constructor(config) {
    if (!this.checkType(config.type)) return

    this.id = config.id || Utils.getGuid()
    this.type = config.type
    this.title = config.title
    this.time = Utils.formatDate(new Date())

    if (config.user) {
      this.user = {
        id: config.user.userId,
        avatar: config.user.avatar,
        name: config.user.name
      }
    }
    if (config.desc) {
      this.desc = config.desc
    }
    if (config.unread !== undefined) {
      this.unread = config.unread
    }
    if (config.callback) {
      this.callback = config.callback
    }

    // 检测是否包含确认关键字
    if (config.title && config.title.includes('点击确认按钮') && config.title.includes('请核对上述信息') ) {
      this.confirmButton = {
        show: true,
        confirmed: false
      }
    }

    this.setPosition()
    this.setSuggestion(config)
    this.setInfoType(config)

    config.success && config.success(this)
  }

  /**
   * 校验类型
   * @param {String} type
   */
  checkType (type) {
    let types = type.split(','),
      count = 0
    for (let i = 0; i < types.length; i++) {
      for (const key in INFO_TYPE) {
        if (types[i].trim() === key) count++
      }
    }
    if (count !== types.length) {
      console.error('Info does not contain this type')
    }
    return count === types.length
  }

  /**
   * 修改标题
   * @param {String} title 标题
   */
  setTitle (title) {
    this.title = title
    this.setPosition(true)
  }

  /**
   * 修改类型
   * @param {String} type
   */
  setType (type) {
    this.type = type
  }

  /**
   * 修改描述
   * @param {String} desc
   */
  setDesc (desc) {
    this.desc = desc
  }

  /**
   * 设置聊天容器位置到底部
  * @param {isSet} isSet 是否时修改后
   */
  setPosition (isSet = false) {
    setTimeout(() => {
      const { id, type, title, callback } = this
      let $wrap = document.querySelector('.chat-wrap'),
        $info = document.getElementById(id),
        wrapHeight = $wrap.clientHeight,
        infoHeight = $info.clientHeight

      if (type.search('IMAGE') > -1) {

        const image = new Image()
        image.src = title.replace(/(^img\[)|(\]$)/g, '')
        image.onload = () => {
          infoHeight = $info.clientHeight

          Utils.toScroll(wrapHeight + infoHeight, 200)
          isSet && callback && callback(this)
        }

      } else {

        Utils.toScroll(wrapHeight + infoHeight, 200)
        isSet && callback && callback(this)

      }
    }, 0)
  }

  /**
   * 设置输入中效果
   * @param {Object} config 配置项
   */
  setInfoType (config) {
    if (!config.type === 'AUTO_REPLY') return

    if (this.type.search('AUTO_REPLY') > -1) {
      const content = this.title
      this.title = '正在输入中...'
      setTimeout(() => {
        this.title = content
        this.setPosition(true)
      }, 800)
    }
  }

  /**
   * 设置文章底部按钮
   * @param {Object} config 配置项
   */
  setSuggestion (config) {
    if (config.content) {
      this.content = config.content
      this.isFold = config.isFold
      this.suggestions = config.suggestions
      this.assess = [{
        name: '有用',
        key: 'like',
        checked: false
      }, {
        name: '没用',
        key: 'unLike',
        checked: false
      }]
    }
  }

}

export default InfoModel


// WEBPACK FOOTER //
// ./src/model/infoModel.js